// extracted by mini-css-extract-plugin
module.exports = {"imgcode":"imgcode___4TSrs","img":"img___3eLLe","largeImg":"largeImg___1-f1Y"};